import React, {useContext, useEffect, useState} from 'react';
// @ts-ignore
import {useHistory, useLocation} from "react-router-dom";
import {RankingsAndLevelsContext} from "../../contexts/RankingsAndLevelsContext";
import RankingsAndLevelsUtils from "../../services/RankingsAndLevelsUtils";
import Constants from "../../data/Constants";
import MapComponent from "./Components/MapComponent";
import {GlobalDataContext} from "../../contexts/GlobalDataContext";
import {ReportDataProps} from "../../interfaces/RankingsAndLevelsInterfaces";

const baseUrl = Constants.routes.rankingsMap;

const MapContainer: React.FC = () => {
    let history = useHistory();
    let location = useLocation();
    const [reportData, setReportData] = useState<ReportDataProps>();

    // @ts-ignore
    const { isLife, setIsLife } = useContext(RankingsAndLevelsContext);
    // @ts-ignore
    const { last10YearReports, lastYearAvailable, allDataLoaded } = useContext(GlobalDataContext);

    useEffect(() =>{
        if(allDataLoaded){
            setReportData(last10YearReports[lastYearAvailable]);
        }
    }, [allDataLoaded]);

    useEffect(() => {
        RankingsAndLevelsUtils.handleQueryParams(location, history, isLife, setIsLife, baseUrl);
    }, []);

    return (
        <MapComponent reportData={reportData} isLife={isLife} allDataLoaded={allDataLoaded}/>
    );
};

export default MapContainer;
